export const PUBLISH_STATE = {
    1: "Preparing",
    2: "Ready",
    3: "Errored",
    4: "Disabled",
    5: "Deleted"
}

export const PUBLISH_STATE_ID = {
    PREPARING: 1,
    READY: 2,
    ERRORED: 3,
    DISABLED: 4,
    DELETED: 5
}